<template>
  <div style="display: inline-block; vertical-align: 10px">
    <template>
      <span>
        <i
          v-if="MerchantHost === documentDomain"
          class="el-icon-bell notifications"
          @click="showNotes(true)"
        >
          <div v-if="notesAmount" class="note-icon">{{ notesAmount }}</div>
        </i>
        <span
          v-if="MerchantHost === documentDomain"
          class="note-type noneSelect"
          @click="showNotes(true)"
          >系统通知</span
        >
      </span>
    </template>
    <el-dialog
      :visible="sysVisible"
      :close-on-click-modal="false"
      custom-class="sys-notice-dialog"
      width="1000px"
      class="custom-dialog-center"
      @close="dialogFormVisible = false"
    >
      <div v-for="(item, idx) in sysNoticeList" :key="idx" class="list-item">
        <div class="header">
          <i class="el-icon-close close-icon" @click="closeSysNotice(idx)" />
          <div v-if="item">{{ item.notificationTitle }}</div>
        </div>
        <div v-if="item" class="content">尊敬的各位商户:</div>
        <div v-if="item" class="content" style="text-indent: 0.7cm">
          {{ item.notificationContext }}
        </div>
        <div class="footer">
          <div>cocopay平台</div>
        </div>
        <div class="footer">
          <div>
            {{ item.notificationDate | parseTime }}
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible="showNewVisible"
      :close-on-click-modal="false"
      :show-close="false"
      custom-class="sys-new-dialog"
      width="500px"
      @close="showNewVisible = false"
      class="custom-dialog-center"
    >
      <div v-if="sysNoticeList && sysNoticeList[0]" class="list-item">
        <div class="header">
          <div>{{ sysNoticeList[0].notificationTitle }}</div>
        </div>
        <div class="content" style="margin-top: 15px">尊敬的各位商户:</div>
        <div class="content" style="text-indent: 0.7cm">
          {{ sysNoticeList[0].notificationContext }}
        </div>
        <div class="footer" style="margin-top: 10px">
          <div>cocopay平台</div>
        </div>
        <div class="footer">
          <div>
            {{
              sysNoticeList[0].notificationDate
                | parseTime
            }}
          </div>
        </div>
        <div class="confirm-btn">
          <el-button type="primary" @click="showNewVisible = false"
            >确 定</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getNotification } from "@/api/merchant/navabar/navabar";
export default {
  data() {
    return {
      documentDomain: "",
      notesAmount: "",
      sysNoticeList: [{ notificationTitle: "", notificationContext: "" }],
      sysNoticeListStore: [],
      sysVisible: false,
      showNewVisible: false,
      sysParams: {
        pageNo: "1",
        pageSize: "99999",
      },
      loading: false,
      dialogFormVisible: false,
      timer: null,
    };
  },
  created() {
    this.getDocumentDomain();
    // this.getNotes();
    // this.timer = setInterval(() => {
    //   this.repeatRequest();
    // }, 30000);
  },

  beforeDestroy() {
    this.timer = null;
  },

  methods: {
    toggleSideBar() {
      this.$store.dispatch("toggleSideBar");
    },
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        location.reload();
      });
    },
    // 域名获取
    getDocumentDomain() {
      this.documentDomain = document.domain;
    },
    isMerchant() {
      // 是商户后台才显示订单通知和系统通知
      return this.MerchantHost.indexOf(document.domain) > -1;
    },
    getNotice(result) {
      setTimeout(() => this.showNotes(false), 0);
    },
    // 系统通知消息
    getNotes() {
      this.isMerchant() &&
        getNotification(this.sysParams).then((data) => {
          var dataList = data.list || [];
          this.sysNoticeList = dataList;
          this.sysNoticeListStore = [];
          dataList.map((val) => {
            this.sysNoticeListStore.push(val);
          });
          this.notesAmount = data.total;
          // 判断系统通知是否有变动
          if (data.total > 0) {
            //  自动弹出弹框
            setTimeout(() => this.showNotes(false), 0);
          }
        });
    },
    // 系统公告列表
    showNotes(status) {
      // 判断是否手动点击
      if (status) {
        getNotification(this.sysParams).then((data) => {
          this.sysNoticeList = data.list;
          this.notesAmount = data.total;
          if (data.total > 0) {
            this.sysVisible = true;
          }
        });
      } else {
        if (this.notesAmount > 0) {
          this.sysVisible = true;
        }
      }
    },
    closeSysNotice(idx) {
      this.sysNoticeList.splice(idx, 1);
      if (this.sysNoticeList.length === 0) {
        this.sysVisible = false;
      }
    },
    // 系统新公告弹出
    showSysNotice() {
      this.sysVisible = false;
      this.showNewVisible = true;
    },
    // 轮询
    repeatRequest() {
      if (this.isMerchant() && localStorage.getItem('userInfo')) {
        // 系统通知
        getNotification(this.sysParams).then((data) => {
          this.notesAmount = data.total;
          this.sysNoticeList = data.list;
          // 判断系统通知第一条是否有变动
          if (data.list.length > 0) {
            if (this.sysNoticeListStore.length === 0) {
              // 直接弹第一条
              this.sysNoticeListStore = [];
              data.list.map((val) => {
                this.sysNoticeListStore.push(val);
              });
              setTimeout(() => this.showSysNotice(), 0);
            } else {
              // 对比第一条
              if (
                this.sysNoticeListStore.length !== data.list.length &&
                this.sysNoticeListStore.length < data.list.length
              ) {
                this.sysNoticeListStore = [];
                data.list.map((val) => {
                  this.sysNoticeListStore.push(val);
                });
                setTimeout(() => this.showSysNotice(), 0);
              } else {
                this.sysNoticeListStore = [];
                data.list.map((val) => {
                  this.sysNoticeListStore.push(val);
                });
              }
            }
          } else {
            this.sysNoticeList = [];
            this.sysNoticeListStore = [];
            this.sysVisible = false;
          }
        });
      }
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.notifications {
  position: relative;
  line-height: 50px;
  font-size: 30px;
  margin-left: 10px;
  cursor: pointer;
}

.note-type {
  font-size: 14px;
  top: -10px;
  cursor: pointer;
  margin-left: 2px;
  margin-right: 5px;
  color: #333333;
}

.note-icon {
  font-size: 12px;
  line-height: 16px;
  color: white;
  font-weight: bold;
  text-align: center;
  position: absolute;
  right: -2px;
  bottom: 30%;
  background: red;
  width: 16px;
  height: 16px;
  border-radius: 50%;
}
</style>

<style rel="stylesheet/scss" lang="scss">
.noneSelect {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.sys-notice-dialog {
  width: 1000px;
  max-height: 700px;
  overflow: auto;
  background: rgba(0, 0, 0, 0);
  box-shadow: unset;
  .el-dialog__header {
    display: none;
    height: 0px;
  }
  .el-dialog__body {
    padding: 0 10px 0 10px;
  }
  .list-item {
    padding: 10px 23px;
    position: relative;
    background: #fff;
    border-radius: 5px;
    margin-bottom: 15px;
    text-align: center;
    .header {
      text-align: center;
      font-size: 20px;
      color: #ff6600;
      .close-icon {
        color: #333333;
        font-size: 28px;
        position: absolute;
        right: 10px;
        top: 10px;
      }
    }
    .content {
      line-height: 28px;
      text-align: left;
    }
    .footer {
      text-align: right;
      line-height: 1;
      padding: 5px;
    }
  }
}
.sys-new-dialog {
  max-height: 800px;
  overflow: auto;
  border-radius: 10px;
  .el-dialog__header {
    display: none;
    height: 0px;
  }
  .el-dialog__body {
    padding: 0 23px 0 23px;
  }
  .header {
    color: #ff0000;
    font-size: 24px;
    text-align: center;
    border-bottom: 1px solid #ccc;
    padding: 10px 0 10px 0;
  }
  .content {
    line-height: 28px;
    text-align: left;
  }
  .footer {
    text-align: right;
    line-height: 28px;
  }
  .confirm-btn {
    text-align: center;
    margin-bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SystematicNotification/SystematicNotification.vue